import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PrescriptionIntakeFlow } from '@/components/prescriptions/PrescriptionIntakeFlow';

export const UploadPrescription = () => {
  const navigate = useNavigate();

  return (
    <PrescriptionIntakeFlow
      role="ADMIN"
      onComplete={() => navigate('/admin/prescriptions')}
      onCancel={() => navigate('/admin/prescriptions')}
      onManualEntry={() => navigate('/admin/prescriptions/new')}
    />
  );
};

export default UploadPrescription;
